import React from "react";

import styles from "./themeTimeLine.module.less";

export default function themeTimeLine({ timeline }) {
  return (
    <div className={`${styles.timelineContainer}`}>
      <div className={`${styles.timeline}`}>
        <div className={`${styles.line}`} />
        <div className={`${styles.timelineEnd}`} />
        {
          timeline.map((tl) => (
            <div className={`${styles.event} ${tl.isTop ? `eventTop-${tl.year}` : `eventBtm-${tl.year}`}`} key={tl.year}>
              <div className={`${tl.isTop ? `${styles.topDot}` : `${styles.btmDot}`}`} />
              <div className={`${tl.isTop ? `${styles.topLine}` : `${styles.btmLine}`}`} />
              <div className={`${styles.textBox}`}>
                <h3>{tl.year}</h3>
                <p>{tl.summary}</p>
              </div>
            </div>
          ))
        }
      </div>
    </div>
  );
}
